import * as types from '../action/actionTypes';
import initialState from './initialState';

export default class UserPreferencesReducer {

    /* Reducer method for user preference  */
    static PreferencesReducer(state = initialState.Preference, action) {
        switch (action.type) {
            case types.GET_USER_PREFERENCES_SUCCESSFULL: return {
                ...state, UserPreference: action.getResponse,
            };
            default: return state;
        }
    }


    /* Reducer method for Cultural language labels  */

    static CulturalLabelsReducer(state = initialState.CulturalLabels, action) {
        switch (action.type) {
            case types.GET_LABELS_BASED_ON_CULTURE_SUCCESSFULL: return {
                ...state, LabelsBasedOnPreference: action.getResponse,
            };

            case types.GET_SYSTEM_ADMIN_LABELS_BASED_ON_CULTURE_SUCCESSFULL: return {
                ...state, SystemAdmin_LabelsBasedOnPreference: action.getResponse,
            };

            case types.GET_DMRESOURCES_LABELS_BASED_ON_CULTURE_SUCCESSFULL: return {
                ...state, DMResource_LabelsBasedOnPreference: action.getResponse,
            }

            case types.GET_WORKORDERS_RESOURCE: return{
                ...state, WorkOrderResource_LabelsBasedOnPreference: action.getResponse,
            }

            case types.GET_DATAVIS_LABELS_BASED_ON_CULTURE_SUCESSFULL: return {
                ...state, DataVis_LabelsBasedOnPreference: action.getResponse,
            }

            case types.GET_REPORTMGMT_LABELS_BASED_ON_CULTURE_SUCESSFULL: return {
                ...state, ReportMgmt_LabelsBasedOnPreference: action.getResponse,
            }

            case types.SET_STATUS_LABELS_BASED_ON_CULTURE_SUCCESSFULL: return {
                ...state, Status_LabelsBasedOnPreference: action.getResponse,
            };

            default: return state;
        }
    }


    /* Reducer method for User details or user info */

    static UserDetailsReducer(state = initialState.UserDetails, action) {
        switch (action.type) {
            case types.GET_USER_INFO: return {
                ...state, user_info: action.getResponse,
            };
            default: return state;
        }
    }

     /* Reducer method for Common Resources  */

     static CommonResourceReducer(state = initialState.CommonResources, action) {
        switch (action.type) {
            case types.GET_COMMON_RESOURCE: return {
                ...state, CommonResourcesData: action.getResponse,
            };
            default: return state;
        }
}


    static ModalOpenCloseReducer(state = initialState.ModalState, action) {
        switch (action.type) {
            case types.CLOSE_MODAL_POPUP: return {
                ...state, ModalOpenClose: { modal_open: action.modal_open },
            };
            default: return state;
        }
    }

    static FacilityDisplayState(state = initialState.FacilityDisplay, action) {
        switch (action.type) {
            case types.CHANGE_VIEW_FACILITY: return {
                ...state, FacilityDisplay: { page_to_display: action.page_to_display },
            };
            default: return state;
        }
    }

}
